export default {
  // 備忘錄
  salary: {
    salary: '薪酬',
    payroll: '工資單',
    salaryAccounting: '薪資核算',
    socialSecurityFund: '社保公積金',
    personalIncomeTax: '個稅專項附加扣除',
    searchMonth: '搜索月份',
    payrollMonth: '計薪月份',
    payrollPlan: '計薪方案',
    payrollNumber: '計薪人數',
    planName: '方案名稱',
    InsuredCity: '參保城市',
    staffJoinNumber: '員工參與人數',
    staffName: '員工姓名',
    mobilePhone: '手機號碼',
    department: '部門',
    childrenEducation: '子女教育',
    housingRent: '住房租金',
    rentalloanInterest: '住房貸款利息',
    supportOldman: '贍養老人',
    continuingEducation: '繼續教育',
    otherDeductions: '其他扣除',
    seeDetails: '查看詳情',
    referenceStaff: '關聯員工',
    seePayrollInputPwd: '查看工資詳情，請輸入密碼',
    tipsPwd: '提示：密碼為系統登錄密碼',
    cexiaoDel: '撤銷後核算薪資結果將從【工資單】中刪除',
    sureCexiao: '確定要撤銷已核算薪資嗎？',
    fabuSalaryResult: '是否要發布該月核算薪酬結果？',
    fabuSalaryResultInfo: '發布後不可更改且發布到【工資單】，員工可通過工資單查看薪資信息',
    sureDelSalary: '確定要刪除核算薪資嗎？',
    payrollCycle: '計薪周期',
    unpublished: '未發布',
    approval: '審批中',
    asbeenReleased: '已發布',
    resigned: '已離職',
    fullName: '姓名',
    realWages: '實發工資',
    thisMonthTiaoxin: '本月有調薪',
    wagesType1: '固定工資',
    wagesType2: '浮動工資',
    wagesType3: '津補貼',
    wagesType4: '考勤',
    wagesType5: '代扣代繳',
    wagesType6: '個稅累計信息',
    wagesType7: '個稅專項附加扣除累計',
    wagesType8: '統計工資',
    sureTongbu: '確定要同步嗎？',
    sureTongbuInfo1:
      '確定後，當前薪酬核算將重新獲取【薪酬設置】的最新規則，將會對固定工資、浮動工資、津補貼、考勤、代扣代繳和個稅進行重新同步，導入數據也將進行清除，現有數據將發生變化。',
    sureTongbuInfo2:
      '確定後，當前薪酬核算將重新獲取【考勤】，考勤內容、應發工資和個稅進行重新同步且對現有數據將發生改變',
    zancun: '暫存',
    thisMonthLastDay: '本月最後壹天',
    salaryHesuanMonth: '薪資核算-月份',
    downloadImportTemplate: '請下載導入模板，根據模板內容完善數據；',
    nameRepeatInputPhone: '若姓名重名，請填寫手機號碼，否則不能識別。',
    lizhi: '離職',
    tiaoxin: '調薪',
    heji: '合計',
    gonghao: '工號',
    wagesType9: '考勤扣款',
    lastMonth: '截止上月',
    zhiwei: '職位',
    addYuandong: '添加員工',
    sureDelHesuan: '確定要刪除核算薪資嗎？',
    sureDelThisData: '確定要刪除該數據嗎？',
    surePushHesuanResult: '是否要發布該月核算薪酬結果？',
    surePushHesuanResultInfo: '發布後不可更改且發布到【工資單】，員工可通過工資單查看薪資信息。',
    sureCexiaoHesuanInfo: '撤消後核算薪資結果將從【工資單】中刪除。',
    sureCexiaoHesuan: '確定要撤銷已核算薪資嗎？',
    dataIsEmpty: '數據有誤',
    pleaseAddYuangong: '請添加員工',
    salaryAccounting1: '薪酬核算',
    accountingZhouqi: '核算周期',
    tongbu1: '同步最新薪酬設置',
    tongbu2: '同步考勤結果',
    editJixinPer: '修改計薪人員',
    editMonthValue: '修改上月個稅累積值',
    clickContent: '單擊數字內容可進行數值修改',
    delYuangong: '刪除員工',
    searchUsername: '搜索姓名',
    geshuiInfo:
      '每月應扣除個稅專項附加扣除費用，每個員工僅可存在壹條數據，用於薪資核算時扣除當月費用。',

    salaryNote: '自動計算機構員工的薪酬，提高財務工作效率。',
    relatedPersonnel: '關聯人事模塊',
    salarySet: '薪酬設置',
    salaryManager: '薪酬管理員',
    associationType: '關聯類型',
    correlationModule: '關聯模塊',
    addCorrelationModule: '添加更多關聯模塊，用於固定工資和浮動工資添加項目時所需要的自定義模塊',
    inductionDate: '入職日期',
    departureDate: '離職日期',
    salaryAdjustmentDate: '調薪日期',
    salaryAdjustmentRecord: '調薪記錄',
    correspondingContent: '項目對應固定工資內容',
    salaryBeforeSalaryAdjustment: '調薪前工資',
    salaryAfterSalaryAdjustment: '調薪後工資',
    associatedNameDate: '關聯姓名/日期',
    correspondingTip:
      '定義系統用戶與關聯模塊姓名之間的對應關系；若需要對應計薪周期則需要選擇日期，若日期為空則僅直接獲取數據第壹條；',
    tableName: '據表名稱',
    relatedName: '關聯姓名',
    relatedData: '關聯日期',
    moduleDeleteTip: '確定要刪除關聯模塊嗎？',
    correspondingTip2: '確定後請去固定工資和浮動工資中對應調整，否則工資項結果有誤。',
    staff: '員工',
    other: '其他',
    staffTble: '員工表',
    resignationApplicationTable: '離職申請表',
    applicationSalaryAdjustmentTable: '調薪申請表',
    dataTable: '數據表',
    schemeAdmin: '方案管理員',
    salaryApproval: '薪酬審批',
    needApproval: '需要審批',
    noNeedApproval: '不需要審批',
    salaryNumber: '薪酬人數',
    modifier: '修改人',
    editTime: '修改時間',
    approvalTip:
      '在薪酬設置審批流程後，提交【薪酬核算】時需走流程審批，審批通過後才發布工資單。若未設置則無須走審批確認後發布。',
    approver: '審批人',
    ruleTip: '可進入後臺設置薪酬規則和在前臺薪酬模塊選取該方案進行每月薪酬核算。',
    approverLength5: '審批人最多5人',
    name: '名稱',
    payCycle: '薪資周期',
    correspondingAttendancePeriod: '與考勤周期對應',
    tothisMonth: '至本月',
    scopeOfApplication: '適用範圍',
    lastMonthlastDay: '上月最後壹天',
    lastDay: '最後壹天',
    remark: '備註',
    nextStep: '下壹步',
    salaryStructureSetting: '薪酬結構設置',
    attendanceCheck: '考勤計薪',
    jinSubsidy: '津補貼',
    lastMonth2: '上月',
    scopeOfApplication_empty: '適用範圍不能為空',
    salaryStructureSettingTip:
      '根據企業的工資表需求，進行薪酬項設計，通過自定義添加滿足企業工資計算需要。設置薪酬結構前請確認已設置“關聯人事模塊”表。',
    wagesTypeTip1: '固定工資計算時區分轉正前、轉正後與調薪進行分別計算，請先在關聯模塊中關聯調薪',
    wagesTypeTip2: '浮動工資根據個人表現進行薪酬發放',
    wagesTypeTip3:
      '企業給員工提供的福利，請在津補貼中設定福利規則，系統將在核算工資時將補貼加入工資表計算中',
    attendanceCheckTip:
      '根據員工的出勤記錄，按壹定規則進行工資計算。請在 考勤計薪 中設定規則，若未設定規則考勤內容將不計入工資計算中。',
    salaryDays: '月標準計薪天數計算',
    attendanceScheduling: '考勤排班',
    standardTime: '標準工時',
    personalSocialSecurity: '個人社保',
    providentFund: '公積金',
    monthly: '每月',
    monthly2: '號前離職將不繳納社保公積金',
    personalTax: '個稅',
    accumulatedRevenue: '累計收入額',
    cumulativeDeductionExpense: '累計減除費用',
    accumulatedSpecialDeduction: '累計專項扣除',
    cumulativeSpecialAdditionalDeduction: '累計專項附加扣除',
    cumulativeOtherDeductions: '累計其他扣除',
    cumulativeTaxPayable: '累計應納稅額',
    wageItem: '工資項',
    dataSource: '數據來源',
    keepDecimalPlaces: '保留小數位',
    decimals: '小數位',
    accuracy: '精確度',
    beforeTaxAfterTax: '稅前/稅後',
    formula: '公式',
    subsidyProject: '津補貼項目',
    inputLength25: '請輸入名稱，限25字內',
    round: '四舍五入',
    tailRemoval: '去尾法',
    enterOne: '進壹法',
    addBeforeTax: '稅前加項',
    preTaxDeduction: '稅前減項',
    addAfterTax: '稅後加項',
    afterTaxDeduction: '稅後減項',
    deleteItem: '確定要刪除該項嗎',
    empty: '不能為空',
    withholdinge_error: '代扣代繳格式錯誤',
    attendanceAndSalary: '考勤計薪人數',
    numberOfSubsidies: '津補貼人數',
    attendanceCheckHandleTip:
      '用於對企業的請假、加班、曠工的考勤計薪設置規則，可根據企業的情況進行設定。',
    leaveDeductionRules: '請假扣款規則',
    leaveTypeTip: '對應考勤模塊中關聯審批單的請假類型。',
    eductionRules: '考勤異常扣款規則',
    eductionRulesTip: '考勤狀態的缺卡、遲到、曠工、早退扣款規則。',
    missingCardNumber: '缺卡次數',
    late: '遲到',
    eaveEarly: '早退',
    absenteeism: '曠工',
    overlapOrDiscontinuity: '次數不允許出現重疊或間斷',
    overtimePayRules: '加班計薪規則',
    overtimeWorkTip: '員工加班，企業給予額外的加班補償，對應考勤模塊中的加班。',
    compensate: '全勤獎和晚班補償',
    fullAttendance: '全勤獎',
    eveningShift: '晚班',
    calculationItem: '計算項',
    calculationItemTip: '請選擇考勤計薪，對應固定工資和浮動工資項稅前加項',
    deductionRatio: '扣款比例',
    numberTip: '請輸入正數且最多保留2位小數',
    noDeductionDuration: '不扣款時長',
    durationMonth: '時長/每月',
    calculationMethod: '計算方式',
    deductionByTimes: '按次數扣款',
    notRange: '補卡不在統計範圍內',
    lateMinuteTip: '每遲到1分鐘，扣款',
    lateTimesTip: '每遲到1次，扣款',
    unit: '單位',
    times: '次數',
    personalization: '個性化設置',
    accumulatedLateEveryMonth: '每月累計遲到',
    lateTime: '次內不扣款',
    lateTime2: '次，且單次遲到時長在',
    lateTime3: '次，且累計遲到時長在',
    eaveEarlyMinuteTip: '分鐘內不扣款',
    eaveEarlyTimesTip: '每早退1分鐘，扣款',
    absenteeismPress: '曠工按',
    doubleSalaryPenalty: '倍工資處罰',
    pleaseEnterNumber: '請輸入數字',
    pleaseEnterInteger: '請輸入整數',
    fixedAmount: '固定金額',
    yuan: '元',
    compensationProportion: '補償比例',
    noFullAttendanceAwardWillBeIssued: '滿足以下條件之壹，不發放全勤獎',
    clockOutTimeExceeds: '下班打卡時間超過',
    nightShiftAward: '晚班獎',
    nightShiftAsChild: '小時計為晚班',
    jinSubsidyTip:
      '按月發放補貼，請在【薪酬結構設置】-津補貼中預設好項目名稱，如高溫補貼、交通補貼、車補、餐補等，發放方式中按天補貼為實際考勤出勤天數',
    monthlySubsidies: '按月發放補貼',
    subsidyByDay: '按天發放補貼',
    jinSubsidyRules: '津補貼規則',
    deductionRules_error: '津補貼輸入框為整數',
    setInsuredBaseAndProportion: '設置參保基數和比例',
    setInsuredAmountOnly: '僅設置參保金額',
    payer: '繳納人員',
    setInsuredTip: '開啟後，“設置參保基數和比例”將被禁用，按該規則來計算社保和公積金',
    associationDataTable: '關聯數據表',
    associatedName: '關聯姓名',
    companySocialSecurity: '關聯機構社保金額',
    personalSocialSecurity2: '關聯個人社保金額',
    companyAccumulationFund: '關聯機構公積金金額',
    personalAccumulationFund: '關聯個人公積金金額',
    paymentCity: '繳納城市',
    paymentBase: '繳納基數',
    schemeContent: '方案內容',
    schemeContentTip: '說明：社保公積金會根據省市區獲取初始化值，之後有變更需人為維護。',
    socialSecurity: '社保',
    projectName: '項目名稱',
    baseLowerLimit: '基數下限',
    baseUpperLimit: '基數上限',
    companyPaymentRatio: '機構繳納比例',
    individualPaymentRatio: '個人繳納比例',
    fixedValue: '固定值',
    EndowmentInsurance: '養老保險',
    medicalInsurance: '醫療保險',
    unemploymentInsurance: '失業保險',
    workInjuryInsurance: '工傷保險',
    maternityInsurance: '生育保險',
    definitePreservation: '確定保存',
    nameRepetition: '名稱不能重復',
    managerTip: '可進入後臺設置薪酬規則和在前臺薪酬模塊選取方案進行每月薪酬核算。',
    schemeAdminTip: '可進入後臺設置社保公積金規則和在前臺關聯員工。',
    commonOperators: '常用運算符',
    selectFormula: '請選擇公式',
    setRule: '設置規則',
    missingCard: '缺卡',
    nightShiftAward_error: '晚班獎格式錯誤',
    clockOutTime_error: '下班打卡時間只可輸入1-8小時',
    fullAttendance_error: '全勤獎格式錯誤',
    compensationProportion_error: '補償比例格式錯誤',
    multiple_error: '倍數格式錯誤',
    error: '格式錯誤',
    amountDeduction_error: '扣款金額格式錯誤',
    pleaseSelectFangan: '請選擇計薪方案',
    pleaseSelectYuefen: '請選擇計薪月份',
    option1: '按元/次數扣款',
    option2: '按固定金額扣款',
    option3: '按曠工時長扣款',
    option4: '按遲到時長扣款',
    option5: '按遲到次數扣款',
    option6: '按單次遲到時長階梯扣款',
    option7: '按月累計遲到時長階梯扣款',
    option8: '按月累計遲到次數階梯扣款',
    option9: '按早退時長扣款',
    option10: '按單次早退時長階梯扣款',
    option11: '按月累計早退時長階梯扣款',
    option12: '按月累計早退次數階梯扣款',
    option13: '按固定金額補償',
    option14: '按工資的壹定比例補償',
    option15: '元/次',
    option16: '時長',
    option17: '元/分鐘',
    option18: '按早退次數扣款',
    place: '位',
    virtualValue: '請輸入有效值',
    deductions: '時長扣款',
    holidaysRequirePay: '節假日需要計薪',
    HD: '小時/天',
    holiday_error: '節假日計薪格式錯誤',
    noJixinPlan: '當前機構無薪酬方案，請去後臺創建方案。',
    minuteslatesingletime: '單次遲到分鐘',
    cumulativeminuteslate: '累計遲到分鐘',
    // 20210305
    pageaddmember: '請先在【薪酬管理員】頁簽中添加人員'
  }
}
